export default __webpack_public_path__ + "static/media/Logo_Blender.e1f1eeb2.svg";